import { Flex, IconError, ListboxOption, mediaMixin, spaceMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledListboxOptionForSkeleton = styled.div`
  width: 100%;
  // Bottom border
  &:after {
    content: '';
    border-bottom: 1px solid ${token('colors.gray300')};
    display: block;
    margin: 0 auto;
    width: 90%;
  }
`;

export const StyledListboxOption = styled(ListboxOption)`
  list-style: none;
  padding: 0 !important;
  min-width: 100%;
  position: relative;

  // Prevents focus from being clipped
  ${mediaMixin(
    'xl',
    css`
      border-left: 3px solid transparent;
      margin-left: -4px;
      margin-right: -4px;

      &:first-child {
        margin-top: -4px;
        &:before {
          border-top: none;
        }
      }
    `,
  )}

  // Top border
    &:before {
    content: '';
    border-top: 1px solid ${token('colors.gray300')};
    display: block;
    margin: 0 auto;
    margin-top: -1px;

    ${mediaMixin(
      'xl',
      css`
        width: 90%;
      `,
    )}

    ${(props) =>
      (props.$isSelected || props.$isActive) &&
      mediaMixin(
        'xl',
        css`
          width: 100%;
        `,
      )}
  }

  // Bottom border
  &:after {
    content: '';
    border-bottom: 1px solid ${token('colors.gray300')};
    display: block;
    margin: 0 auto;

    ${mediaMixin(
      'xl',
      css`
        width: 90%;
      `,
    )}

    ${(props) =>
      (props.$isSelected || props.$isActive) &&
      mediaMixin(
        'xl',
        css`
          width: 100%;
        `,
      )}
  }

  ${(props) =>
    props.$isBlurred &&
    css`
      opacity: 0.5;
    `}

  // Background is applied in ConversatioList on active item if listbox is in focus
    ${(props) =>
    props.$isActive &&
    css`
      background: none !important;
    `}

    ${(props) =>
    props.$isSelected &&
    mediaMixin(
      'xxl',
      css`
        border-left: 3px solid ${token('colors.brand')};
        background-color: ${token('colors.gray100')} !important;
      `,
    )}
`;

export const StyledUnreadBadgeIndicator = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 9px;
  background-color: ${token('colors.brand')};
  margin-right: 5px;
  padding-left: ${spaceMixin('xs')};
`;

export const StyledSpanItemIconContainer = styled.span`
  > svg {
    background-size: 13px;
    height: 13px;
    width: 13px;
    margin: 0 auto;
    display: inline-block;
    position: relative;
    margin-right: 5px;
    top: 1px;
  }
`;

export const StyledSwipeContainer = styled(Flex)`
  align-items: center;
  display: flex;
  height: 100%;
  width: 100%;
  padding-left: ${spaceMixin('md')};
  padding-right: ${spaceMixin('md')};

  ${(props) =>
    props.$isArchiveContent &&
    css`
      background-color: ${token('colors.gray300')};
      & svg {
        margin-left: auto;
      }
    `}

  ${(props) =>
    props.$isMoveToInboxContent &&
    css`
      background-color: ${token('colors.green100')};
    `}
`;

export const StyledIconError = styled(IconError)`
  margin-right: 4px;
  position: relative;
  top: -1px;
`;
